(function () {
    'use strict';

    angular.module('app.relatedProductType', [
        // Angular modules 
        'ngRoute'

        // Custom modules 

        // 3rd Party Modules
        
    ]);
})();